module.exports = __webpack_public_path__ + "static/media/icon-deposit.ee555dfc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-deposit.svg
// module id = 1253
// module chunks = 19